import CommonLayout from "layouts/DashboardLayout"
import AngleRightIcon from "common/customIcons/angle_right"
import { useNavigate, useParams } from "react-router"
import { Box, Card, colors, Grid, IconButton, Stack, Tooltip, Typography } from "@mui/material"
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from "react-redux";
import { useEffect, useState } from "react";
import defaultProductImage from 'assets/images/placeholder-image.png';
import { getDetailMigrateAuthors } from "../../redux/apis/blogs";
import Loader from "common/Loader";
import { useSelector } from "react-redux";
import defaultImage from 'assets/images/placeholder-image.png';

export default function ViewAuthorPage() {
    const { grey } = colors;
    const { authorId } = useParams()
    const navigate = useNavigate()
    const dispatch = useDispatch();
    const { fetchingAuthor, currentAuthor } = useSelector((state) => state.blogs);
    console.log("currentAuthor", currentAuthor);

    useEffect(() => {
        dispatch(getDetailMigrateAuthors(authorId)).unwrap().then((res) => {
        }).catch((err) => {
        })
    }, [])

    return (
        <CommonLayout>
            <Grid item xs={12} sm={4} md={2} xxl={2}>
                <Box p={{ xs: 2, sm: 3, lg: 4 }} style={{ paddingBottom: 0 }}>
                    <Box display="flex" alignItems="center" justifyContent={'space-between'} mb={2}>
                        <Box display="flex" alignItems="center" color='text.main' lineHeight={1}>
                            <span style={{ cursor: 'pointer', display: "flex", alignItems: "center" }} onClick={() => { navigate('/manages/author') }}>
                                <AngleRightIcon fontSize="14px" />
                                <Typography variant='h6' fontWeight="semibold" ml={.75}>{authorId ? currentAuthor?.name : 'Author'}</Typography>
                            </span>
                        </Box>

                    </Box>
                    {
                        fetchingAuthor ? <Loader /> : <Card
                            sx={{
                                p: { xs: 2, md: 3 },
                                borderRadius: 2.5,
                                boxShadow: 'none',
                                backgroundColor: "#F5F5FF",
                            }}
                        >

                            <Grid container alignItems="center" spacing={{ xs: 2, md: 3 }}>
                                <Grid item xs={12}>
                                    <Typography variant='body2' color={grey[600]} mb={1}>Author Image</Typography>
                                    <Stack direction="row" spacing={1.25}>
                                        <img
                                            style={{ borderRadius: '50%', width: '100px', height: '100px', objectFit: 'cover' }}
                                            src={currentAuthor?.image?.url || defaultProductImage}
                                            alt="Author"
                                        />
                                    </Stack>
                                </Grid>

                                <Grid item xs={12}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12}>
                                            <Typography variant='body2' color={grey[600]} mb={1}>Author Name</Typography>
                                            <Typography variant='h5' fontWeight="medium">{currentAuthor?.name || "-"}</Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant='body2' color={grey[600]} mb={1}>Description</Typography>
                                    <Typography
                                        variant="h5"
                                        fontWeight="medium"
                                        dangerouslySetInnerHTML={{ __html: currentAuthor?.description || "-" }}
                                    />
                                </Grid>
                                {
                                    currentAuthor?.socialMediaLinks?.length !== 0 &&
                                    <Grid item xs={12}>
                                        <Typography variant='body2' color={grey[600]} mb={1}>Social Media Icons</Typography>
                                        <Box display="flex" gap={1}>
                                            {currentAuthor?.socialMediaLinks?.map((link) => (
                                                <IconButton key={link?.platform} sx={{ p: 0 }} href={link?.link} target="_blank">
                                                    <img width={26} height={26} style={{ objectFit: "cover", borderRadius: "50%" }} src={link.imageUrl || defaultImage} />
                                                </IconButton>
                                            ))}
                                        </Box>
                                    </Grid>
                                }
                            </Grid>
                        </Card>
                    }
                </Box>
            </Grid>
        </CommonLayout>
    )
}